import { IndustrialProcessSchema, type IndustrialProcessType } from "../types";

export type MachineTimesGrouping = "thickness" | "diameter" | "material" | "allLines";

export const GROUPING_RULES_BY_PROCESS = {
  [IndustrialProcessSchema.enum.FOLDING]: "thickness",
  [IndustrialProcessSchema.enum.LASER_CUT]: "thickness",
  [IndustrialProcessSchema.enum.PLASMA_CUT]: "thickness",
  [IndustrialProcessSchema.enum.WATER_CUT]: "thickness",
  [IndustrialProcessSchema.enum.COMBINED_PUNCHING_LASER]: "thickness",
  [IndustrialProcessSchema.enum.PUNCHING]: "thickness",
  [IndustrialProcessSchema.enum.SHEARING]: "thickness",
  [IndustrialProcessSchema.enum.DEBURRING]: "thickness",
  [IndustrialProcessSchema.enum.UNSTAPLING]: "thickness",
  [IndustrialProcessSchema.enum.ROLLING]: "thickness",
  [IndustrialProcessSchema.enum.ELECTRO_EROSION]: "thickness",
  [IndustrialProcessSchema.enum.PRESSING]: "thickness",
  [IndustrialProcessSchema.enum.TURNING]: "diameter",
  [IndustrialProcessSchema.enum.MILLING]: "diameter",
  [IndustrialProcessSchema.enum.DRILLING]: "diameter",
  [IndustrialProcessSchema.enum.TAPPING]: "diameter",
  [IndustrialProcessSchema.enum.COUNTERSINKING]: "diameter",
  [IndustrialProcessSchema.enum.BENDING]: "diameter",
  [IndustrialProcessSchema.enum.ENGRAVING]: "material",
  [IndustrialProcessSchema.enum.CHIMIC_ENGRAVING]: "material",
  [IndustrialProcessSchema.enum.WELDING]: "material",
  [IndustrialProcessSchema.enum.CONTROL]: "allLines",
  [IndustrialProcessSchema.enum.PACKING]: "allLines",
  [IndustrialProcessSchema.enum.ASSEMBLING]: "allLines",
  [IndustrialProcessSchema.enum.CRIMPING]: null,
  [IndustrialProcessSchema.enum.GRINDING]: null,
  [IndustrialProcessSchema.enum.HEAT_TREATMENT]: null,
  [IndustrialProcessSchema.enum.MATERIAL]: null,
  [IndustrialProcessSchema.enum.OTHER]: null,
  [IndustrialProcessSchema.enum.OUTSOURCING]: null,
  [IndustrialProcessSchema.enum.PRODUCTS]: null,
  [IndustrialProcessSchema.enum.RIVETING]: null,
  [IndustrialProcessSchema.enum.SAWING]: null,
  [IndustrialProcessSchema.enum.SIMPLE]: null,
  [IndustrialProcessSchema.enum.SURFACE_TREATMENT]: null,
  [IndustrialProcessSchema.enum.TRANSPORT]: null,
  [IndustrialProcessSchema.enum.TRIMMING]: null,
} satisfies Record<IndustrialProcessType, MachineTimesGrouping | null>;
